export const DEFAULT_VALID_FILE_EXTENSIONS: ReadonlyArray<string> = [
  '.pdf',
  'image/jpeg',
  'image/png',
];
export const DEFAULT_MAX_UPLOADS_COUNT = 5;
